<template>
  <div class="container">
  <ol class="breadcrumb">
    <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
    <li class="active">Serials</li>
  </ol>

  <div class="row">
    <div class="col-sm-6">
      <date-range-picker @daterange-change="dateRangeChange"></date-range-picker>
    </div>
    <div class="col-sm-6">
      <h5>{{ dateRangeFormat(dateStart) }} - {{ dateRangeFormat(dateEnd) }}</h5>
    </div>
  </div>

  <div class="row">

    <div class="col-sm-2 button-wrapper">
      <button @click="clearFilters" class="btn btn-default" type="button">Clear All Filters</button>
    </div>

    <div class="col-sm-3">
      <p>Showing {{ filteredSerialCount }} of {{ serialCount }} serials</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3 col-sm-6">
      <input v-model="searchTerm" type="text" class="form-control" placeholder="Search...">
    </div>
    <div class="col-md-3 col-sm-6">
      <select v-model="selectedCustomer" class="form-control">
        <option value="">Select Customer</option>
        <option v-for="customer in customers">{{ customer }}</option>
      </select>
    </div>
    <div class="col-md-3 col-sm-6">
      <select v-model="selectedCity" class="form-control">
        <option value="">Select City</option>
        <option v-for="city in cities">{{ city }}</option>
      </select>
    </div>
    <div class="col-md-3 col-sm-6">
      <select v-model="selectedCountry" class="form-control">
        <option value="">Select Country</option>
        <option v-for="country in countries">{{ country }}</option>
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <table class="table">
        <thead>
          <th>Serial</th>
          <th>Customer</th>
          <th>Service Tag</th>
          <th>City</th>
          <th>Country</th>
          <th>Software Version</th>
          <th>Last Tracked</th>
        </thead>
        <tbody>
          <tr v-for="details in filteredSerials">
            <td>
              <router-link :to="{ name: 'serial', params: { id: details.serial }}">{{ details.serial8 }}</router-link>
            </td>
            <td>{{ details.customer }}</td>
            <td>{{ details.serviceTag }}</td>
            <td>{{ details.city }}</td>
            <td>{{ details.country }}</td>
            <td>{{ details.softwareVersion }}</td>
            <td>{{ details.lastTracked }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- <p>{{ serials }}</p> -->
</div>
</template>

<style scoped>
.button-wrapper {
  margin-bottom: 5px;
}
</style>

<script>
import moment from 'moment'
import _ from 'underscore'
import escapeStringRegexp from 'escape-string-regexp'
import DateRangePicker from './DateRangePicker'
import * as mutationTypes from '../store/mutation-types'
import C from '../constants'

export default {
  components: {
    DateRangePicker
  },

  data () {
    return {
      serials: []
    }
  },

  computed: {
    dateRange: {
      get () {
        return this.$store.state.filterDateRange.dateRange
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value)
      }
    },
    selectedCustomer: {
      get () {
        return this.$store.state.filterSerialList.selectCustomer
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_SERIALS_SELECT_CUSTOMER, value)
      }
    },
    selectedCity: {
      get () {
        return this.$store.state.filterSerialList.selectCity
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_SERIALS_SELECT_CITY, value)
      }
    },
    selectedCountry: {
      get () {
        return this.$store.state.filterSerialList.selectCountry
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_SERIALS_SELECT_COUNTRY, value)
      }
    },
    searchTerm: {
      get () {
        return this.$store.state.filterSerialList.search
      },

      set (value) {
        this.$store.commit(mutationTypes.FILTER_SERIALS_SEARCH, value)
      }
    },
    dateStart () {
      return moment(this.dateRange[0], C.M_FMT_MS).utc()
    },

    dateEnd () {
      return moment(this.dateRange[1], C.M_FMT_MS).utc()
    },
    epochStart () {
      return this.dateRange[0]
    },
    epochEnd () {
      return this.dateRange[1]
    },
    serialCount () {
      return this.reducedSerials.length
    },
    filteredSerialCount () {
      return this.filteredSerials.length
    },
    customers () {
      return this.pluckFilterValues('customer')
    },
    cities () {
      return this.pluckFilterValues('city')
    },
    countries () {
      return this.pluckFilterValues('country')
    },
    reducedSerials () {
      return _.map(this.serials, (val, key) => {
        return {
          serial: key,
          serial8: key.substring(0, 8),
          customer: val.details.length > 0 ? val.details[0].customer : '',
          serviceTag: val.details.length > 0 ? val.details[0].serviceTag : '',
          city: val.latestTrack.location.city || '',
          country: val.latestTrack.location.country_name || '',
          softwareVersion: val.latestTrack.softwareVersion,
          lastTracked: moment(val.latestTrack.range).format('YYYY-MM-DD HH:mm:ss')
        }
      })
    },
    filteredSerials () {
      var vm = this
      var re = new RegExp(escapeStringRegexp(this.searchTerm), 'ig')

      return _.chain(this.reducedSerials)
      .filter(function (val) {
        return (
          (vm.searchTerm === '' ||
            (val.serial.match(re) ||
            val.serviceTag.match(re) ||
            val.customer.match(re) ||
            val.city.match(re) ||
            val.country.match(re))) &&

          (vm.selectedCustomer === '' || (vm.selectedCustomer !== '' && vm.selectedCustomer === val.customer)) &&
          (vm.selectedCity === '' || (vm.selectedCity !== '' && vm.selectedCity === val.city)) &&
          (vm.selectedCountry === '' || (vm.selectedCountry !== '' && vm.selectedCountry === val.country))
        )
      })
      .sortBy('lastTracked')
      .reverse()
      .value()
    }
  },

  mounted () {
    this.fetch()
  },

  methods: {
    dateRangeChange (e) {
      this.dateRange = e
    },
    fetch () {
      this.$store.commit(mutationTypes.LOADER_LOADING)
      this.$apiWsoc.fetchDetails(null, this.epochStart, this.epochEnd)
      .then((result) => {
        this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
        // console.log('serial list fetched', result)
        this.serials = result
      })
      .catch((error) => {
        this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
        console.log('serial list fetch error', error)
      })
    },
    clearFilters () {
      this.searchTerm = ''
      this.selectedCity = ''
      this.selectedCountry = ''
      this.selectedCustomer = ''
    },
    pluckFilterValues (key) {
      return _.chain(this.reducedSerials)
      .pluck(key)
      .uniq()
      .without('')
      .sortBy()
      .value()
    },
    dateRangeFormat (date) {
      return moment(date).format(C.M_FMT_READABLE_WEEKDAY)
    }
  },

  watch: {
    dateRange: function () {
      this.fetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// SerialList.vue?0d21a7cb